"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _OrderDetail = _interopRequireDefault(require("@/components/OrderDetail"));
var _memberOrder = require("@/api/member/memberOrder");
var _index = require("@/utils/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    OrderDetail: _OrderDetail.default
  },
  props: {
    memberData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        orderSn: '',
        orderSaleType: '',
        orderStatus: '',
        shippingStatus: '',
        payStatus: '',
        groupType: '',
        addTimeRange: [],
        mobile: ''
      },
      // 高级筛选显示状态
      showAdvanced: false,
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    // 搜索功能
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchOrderList();
    },
    // 获取订单列表
    fetchOrderList: function () {
      var _fetchOrderList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
                page: this.currentPage,
                limit: this.pageSize,
                userId: this.memberData.userId || this.memberData.id
              }); // 处理时间范围数据
              if (this.searchForm.addTimeRange && this.searchForm.addTimeRange.length === 2) {
                params.addTimeStart = this.searchForm.addTimeRange[0];
                params.addTimeEnd = this.searchForm.addTimeRange[1];
              }
              // 删除addTimeRange字段，因为后端不需要这个字段
              delete params.addTimeRange;

              // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context.next = 2;
              return (0, _memberOrder.getMemberOrders)(params);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取订单列表失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('获取订单列表失败:', _t);
              this.$message.error('获取订单列表失败');
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchOrderList() {
        return _fetchOrderList.apply(this, arguments);
      }
      return fetchOrderList;
    }(),
    // 切换高级筛选显示/隐藏
    toggleAdvanced: function toggleAdvanced() {
      this.showAdvanced = !this.showAdvanced;
    },
    // 导出功能
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.$message.info('正在导出订单数据...');
              params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
                userId: this.memberData.userId || this.memberData.id
              }); // 处理时间范围数据
              if (this.searchForm.addTimeRange && this.searchForm.addTimeRange.length === 2) {
                params.addTimeStart = this.searchForm.addTimeRange[0];
                params.addTimeEnd = this.searchForm.addTimeRange[1];
              }
              // 删除addTimeRange字段，因为后端不需要这个字段
              delete params.addTimeRange;

              // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context2.next = 1;
              return (0, _memberOrder.exportMemberOrders)(params);
            case 1:
              response = _context2.sent;
              if (response && response.code === 200) {
                this.$message.success(response.message || '数据导出中，请稍后查看下载文件');
              } else {
                this.$message.error(response.message || '导出失败');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('导出失败:', _t2);
              this.$message.error('导出失败：' + (_t2.message || '网络异常'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    // 查看详情
    handleViewDetail: function handleViewDetail(row) {
      // 通过事件向父组件发送消息，打开订单详情标签页
      this.$emit('open-order-detail', {
        orderData: row,
        title: "\u8BA2\u5355\u8BE6\u60C5 - ".concat(row.orderSn)
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchOrderList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchOrderList();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      // 如果是时间戳，转换为日期对象
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000;
      }
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取完整地址
    getAddress: function getAddress(row) {
      var addressParts = [row.countryStr, row.provinceStr, row.cityStr, row.districtStr, row.address].filter(function (part) {
        return part;
      });
      return addressParts.join(' ') || '暂无地址';
    },
    // 检查是否有经纬度信息
    hasLatLng: function hasLatLng(row) {
      return row.lat || row.lng;
    },
    // 获取经纬度信息
    getLatLng: function getLatLng(row) {
      var latLng = [];
      if (row.lat) latLng.push(row.lat);
      if (row.lng) latLng.push(row.lng);
      return latLng.join(', ') || '';
    },
    // 获取订单销售类型文本
    getOrderSaleTypeText: function getOrderSaleTypeText(type) {
      var typeMap = {
        1: '堂食',
        2: '自取',
        3: '打包',
        4: '外卖'
      };
      return typeMap[type] || '未知';
    },
    // 获取订单状态文本
    getOrderStatusText: function getOrderStatusText(status) {
      var statusMap = {
        0: '未确认',
        1: '已确认',
        2: '已取消',
        3: '无效',
        4: '退货',
        5: '已分单',
        6: '部分分单',
        7: '已完结'
      };
      return statusMap[status] || '未知';
    },
    // 获取配送状态文本
    getShippingStatusText: function getShippingStatusText(status) {
      var statusMap = {
        0: '未发货',
        1: '已发货',
        2: '已收货',
        3: '备货中',
        4: '已发货(部分)',
        5: '发货中',
        6: '已选仓'
      };
      return statusMap[status] || '未知';
    },
    // 获取支付状态文本
    getPayStatusText: function getPayStatusText(status) {
      var statusMap = {
        0: '未付款',
        1: '付款中',
        2: '已付款'
      };
      return statusMap[status] || '未知';
    },
    // 获取发票状态文本
    getInvoiceStatusText: function getInvoiceStatusText(status) {
      var statusMap = {
        0: '未开票',
        1: '已申请',
        2: '已审核',
        3: '已开票'
      };
      return statusMap[status] || '未知';
    }
  },
  mounted: function mounted() {
    // 如果传入了会员数据，可以根据会员信息过滤数据
    if (this.memberData) {
      console.log('会员订单 - 会员信息:', this.memberData);
      // 初始化时获取订单数据
      this.fetchOrderList();
    }
  }
};